// @flow

export default (props) => {
  switch (props.decorator || props.is) {
    case 'AddSvgIconSprite':
      return import('./components/AddSvgIconSprite');
    case 'RadioSelect':
    case 'CheckboxSelect':
      return import('fg-frontend/src/components/RadioSelect');
    case 'SimpleCollapse':
      return import('fg-frontend/components/SimpleCollapse');
    case 'UniversalPaginationButton':
      return import('fg-frontend/components/UniversalPaginationButton');
    case 'TriggerInViewport':
      return import('./components/TriggerInViewport');
    case 'PhotoSwipe':
      return import('./components/PhotoSwipe');
    case 'RedirectToUrl':
      return import('fg-frontend/src/components/RedirectToUrl');
    case 'PrintPage':
      return import('fg-frontend/src/components/PrintPage');
    case 'PrintPdf':
      return import('fg-frontend/src/components/PrintPdf');
    case 'Header':
      return import('./components/Header');
    case 'Form':
      return import('./components/Form');
    case 'AnimateInViewport':
      return import('./components/AnimateInViewport');
    case 'News':
      return import('./components/News');
    case 'Quiz':
      return import('./components/Quiz');
    case 'NewsSupport':
      return import('./components/NewsSupport');
    case 'NewsDetail':
      return import('./components/NewsDetail');
    case 'TileSlider':
      return import('./components/TileSlider');
    case 'NewsItemSlider':
      return import('./components/NewsItemSlider');
    default:
      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-bn/src/js/configureWebComponents.js